module.exports = __webpack_public_path__ + "img/quickstart.b81963f9.gif";